<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid">
	<div class="FormGrid">
		<label>Homeroom:</label>
		<label>{{ SelectedHomeroom.Homeroom }}</label>

		<label>Academy</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="AcademyID" [(ngModel)]="AcademyID">
			<option *ngFor="let r of lstAcademy" [ngValue]="r.AcademyID">
				{{ r.AcademyDesc }}
			</option>
		</select>

		<label>Homeroom Administrator</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DirectorID" [(ngModel)]="SelectedAdmin">
			<option *ngFor="let r of lstStaff" [ngValue]="r">{{ r.StaffFullName }}</option>
		</select>

		<label>Assigned Advisor</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="DirectorID" [(ngModel)]="SelectedAdvisor">
			<option *ngFor="let r of lstStaff" [ngValue]="r">{{ r.StaffFullName }}</option>
		</select>
	</div>

	<div class="InfoMenu">
		<label class="InfoText">Tardy Time is set in the 'School Settings' menu item under the 'Tardy Time'</label>
	</div>
</div>
<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
